import React from 'react';

import classNames from 'classnames';

import { ErrorBoundary } from '@nxte-nl/error-boundary';

import {
  Typography,
  Props as TypographyProps,
} from '../Typography/Typography';
import styles from './DangerouslySetInnerHtml.module.css';

export type Props = Omit<TypographyProps, 'component' | 'children'> & {
  dangerousHtml: string;
};

export const DangerouslySetInnerHtml = React.memo((props: Props) => {
  const {
    className,
    dangerousHtml,
    dataTau,
    ...rest
  } = props;

  return (
    dangerousHtml ? (
      <ErrorBoundary>
        <Typography
          dataTau={dataTau}
          className={classNames(
            styles.dangerouslySetInnerHtml,
            className,
          )}
          component='div'
          {...rest}
        >
          <div dangerouslySetInnerHTML={{ __html: dangerousHtml }} />
        </Typography>
      </ErrorBoundary>
    ) : null
  );
});

DangerouslySetInnerHtml.displayName = 'DangerouslySetInnerHtml';
